import { Controller } from '@hotwired/stimulus';
import SignaturePad from 'signature_pad';

export default class extends Controller {
    static get targets() {
        return ['pad', 'clear', 'save', 'holder', 'input'];
    }

    connect() {
        this._signaturePad = new SignaturePad(this.padTarget, {
            backgroundColor: '#ffffff',
            penColor: '#000',
        });

        this.clearTarget.addEventListener('click', () => {
            this._signaturePad.clear();
            const ctx = this.padTarget.getContext('2d');
            ctx.fillStyle = '#ffffff';
            ctx.fillRect(0, 0, this.padTarget.width, this.padTarget.height);
            this.inputTarget.value = '';
        });

        this._signaturePad.addEventListener('endStroke', () => {
            if (!this._signaturePad.isEmpty()) {
                const data = this.toPngDataURL();
                this.inputTarget.value = data;
                this.inputTarget.dispatchEvent(new Event('change'));
            }
        });

        window.addEventListener('resize', () => {
            this.resizeCanvas();
        });

        document.addEventListener('disclaimer:filling-for-changed', () => {
            this.resizeCanvas();
        });
    }

    cropSVG(svgText) {
        const tempElement = document.createElement('div');
        tempElement.setAttribute('style', 'visibility: hidden');
        document.body.appendChild(tempElement);
        tempElement.innerHTML = svgText;

        const svgElement = tempElement.getElementsByTagName('svg')[0];
        const bbox = svgElement.getBBox();

        const viewBox = [bbox.x - 5, bbox.y - 5, bbox.width + 10, bbox.height + 10].join(' ');
        svgElement.setAttribute('viewBox', viewBox);

        svgElement.removeAttribute('width');
        svgElement.removeAttribute('height');

        const croppedSVG = svgElement.outerHTML;
        document.body.removeChild(tempElement);

        return croppedSVG;
    }

    toPngDataURL() {
        const canvas = this.padTarget;

        // Create a new canvas with white background
        const tempCanvas = document.createElement('canvas');
        tempCanvas.width = canvas.width;
        tempCanvas.height = canvas.height;
        const ctx = tempCanvas.getContext('2d');

        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, tempCanvas.width, tempCanvas.height);

        ctx.drawImage(canvas, 0, 0);

        return tempCanvas.toDataURL('image/png');
    }

    resizeCanvas() {
        const parent = this.padTarget.parentElement;
        const width = parent.offsetWidth;
        const maxWidth = 600;
        const maxHeight = 300;

        this.padTarget.width = width > maxWidth ? maxWidth : width;
        this.padTarget.height = width / 2 > maxHeight ? maxHeight : width / 2;

        this._signaturePad.clear();
        const ctx = this.padTarget.getContext('2d');
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, this.padTarget.width, this.padTarget.height);
    }
}
